export default {
  LOAD_LIST_AGENDA(state, data) {
    state.listaUsers = data
  },
}
